import React from "react";
import styled from "styled-components";

interface IProps {
  colors: string[];
  scale: number;
}

const Container = styled.div<{scale: number}>`
  display: grid;
  grid-template-rows: repeat(4, 1fr);
  grid-auto-flow: column;
  position: relative;
  width: 1240px;
  height: 1844px;
  transform: scale(${props => props.scale});
  transform-origin: left top;
  
`
const Block = styled.div<{color: string}>`
  color: ${props => props.color};
  font-size: 60px;
  font-weight: bold;
  text-align: center;
  padding-top: 60px;
  border: solid 1px red;
`;

const GraphicNames12CutPresetView = ({
  colors,
  scale
}: IProps) => {
  return (
    <Container
      scale={scale}
    >
      {colors?.map((color, index) => {
        return (
          <Block key={index} color={`#${color}`}>{index + 1} : {`#${color}`}</Block>
        )
      })}
    </Container>
  )
}

export default GraphicNames12CutPresetView;